/**
 * API response'undaki hotel verisini LandingCardItem formatına çevirir
 * @param {Object} hotel - API'den gelen hotel objesi
 * @returns {Object} LandingCardItem formatında hotel objesi
 */

const getRatingText = (score) => {
  if (typeof score !== 'number' || score <= 0) return null;
  if (score >= 9) return 'Harika';
  if (score >= 8) return 'Çok İyi';
  if (score >= 7) return 'İyi';
  if (score >= 6) return 'Fena Değil';
  return null;
};

export const mapLandingHotelItem = (hotel) => {
  // Rating kontrolü
  const surveyScore = hotel?.SurveyScore;
  const isValidRating = typeof surveyScore === 'number' && surveyScore > 0;

  // Image URL'i array'e çevir
  const imageUrl = hotel?.ImageUrl || hotel?.DesktopImageUrl || '';
  const imageUrlArray = imageUrl ? [imageUrl] : ['/images/dummy/hotel-placeholder.jpg'];
  const images = Array.isArray(hotel?.Images) && hotel.Images.length > 0 ? hotel.Images : imageUrlArray;

  // Amenities'i map et (highlighted olanları al)
  // API response'unda camelCase kullanılıyor (highlighted, code, name)
  const amenities = (hotel?.Amenities || [])
    .filter((amenity) => amenity.highlighted === true)
    .map((amenity) => ({
      Code: amenity.code || amenity.Code,
      Name: amenity.name || amenity.Name,
    }));

  // Address.areas'dan locationId al (varsa ilk area'nın id'sini kullan)
  const locationId = hotel?.Address?.areas?.[0]?.id || null;

  return {
    id: hotel?.HotelId,
    name: hotel?.HotelName || 'Otel',
    hotelSlug: hotel?.HotelSlug || '',
    starRating: hotel?.StarNumber || 0,
    location: hotel?.LocationName || '',
    locationId: locationId,
    rating: isValidRating ? surveyScore : null,
    ratingText: isValidRating ? getRatingText(surveyScore) : null,
    reviewCount: hotel?.ReviewCount || 0,
    breakfast: null, // Landing page'de breakfast bilgisi yok
    amenities: amenities,
    link: hotel?.HotelRouterUrl?.Value || `/otel/${hotel?.HotelSlug || hotel?.HotelId || ''}`,
    imageUrl: imageUrlArray,
    Images: images,
    // Favori state'i (API'den geliyorsa)
    IsFavorited: hotel?.IsFavorited || false,
    FavoriteId: hotel?.FavoriteId || null,
    // Analytics / datalayer için API alanları
    Address: hotel?.Address ?? null,
    Tags: hotel?.Tags ?? null,
    MarketType: hotel?.MarketType ?? null,
    ProviderId: hotel?.ProviderId ?? null,
    CheckinDate: hotel?.CheckinDate ?? null,
    CheckoutDate: hotel?.CheckoutDate ?? null,
  };
};

